import React, { Component } from 'react';
import { Container, Grid, Segment, Message, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';

import GroupCareLogoHorImage from './minsights_intro.jpg';

class HradminDashboardPage extends Component {
    render() {
        const isMInsightsReady = (this.props.mhcInsightsUrl) ? true : false;
        return (
            <Container>
                <Grid columns={1}>
                    <Grid.Column>
                        <Segment textAlign="center">
                            <Message info>
                                Welcome to GroupCare HR Admin Portal
                            </Message>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment textAlign="center">
                        {
                            (isMInsightsReady === true) ? 
                            (
                                <a href={this.props.mhcInsightsUrl} target="_blank">
                                    <Image src={GroupCareLogoHorImage} />
                                </a>
                            )
                            :
                            (
                                <Image src={GroupCareLogoHorImage} disabled />
                            )
                        }
                        </Segment>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        mhcInsightsUrl: state.hradmin.mhcInsightsUrl,
    };
}

export default connect(mapStateToProps)(HradminDashboardPage);